import React from 'react';
import { Anchor } from '@sitebase/ui-kit/es/buttons';

import { CLASSNAME_PREFIX } from '../../componentConfig';
import './GamblingHelpSection.scss';
import { GamblingHelpSectionTracker } from '@myaccount/tracker';

export var GamblingHelpSection = function GamblingHelpSection(_ref) {
  var translate = _ref.translate,
      config = _ref.config,
      mainText = _ref.mainText,
      shouldShowGamstopSection = _ref.shouldShowGamstopSection,
      countryCode = _ref.countryCode,
      tracker = _ref.tracker;

  var mainButtonOutfit = shouldShowGamstopSection ? 'white' : 'blue';
  var mainButtonTheme = shouldShowGamstopSection ? 'light' : 'dark';
  var shouldShowLink = countryCode === 'UK';
  var handleGamStopClick = function handleGamStopClick() {
    tracker.gamstopClicked();
  };

  return React.createElement(
    'div',
    { className: CLASSNAME_PREFIX + '-help-section' },
    React.createElement(
      'div',
      { className: CLASSNAME_PREFIX + '-help-section__border' },
      React.createElement(
        'div',
        { className: CLASSNAME_PREFIX + '-help-section__border-content' },
        React.createElement('div', {
          className: CLASSNAME_PREFIX + '-help-section__main-button-text',
          dangerouslySetInnerHTML: { __html: mainText }
        }),
        React.createElement(
          'div',
          { className: CLASSNAME_PREFIX + '-help-section__main-button-wrapper' },
          React.createElement(
            Anchor,
            {
              className: CLASSNAME_PREFIX + '-help-section__main-button ' + CLASSNAME_PREFIX + '-help-section__main-button-' + mainButtonTheme,
              href: config.mainButtonLink,
              target: '_blank',
              rel: 'noopener noreferrer',
              outfit: mainButtonOutfit + ' button blue large expanded'
            },
            translate('saferGambling.views.gamblingHelpSection.mainButtonText')
          )
        )
      )
    ),
    shouldShowGamstopSection && React.createElement(
      'div',
      { className: CLASSNAME_PREFIX + '-help-section__gamstop-section' },
      React.createElement(
        'h5',
        null,
        translate('saferGambling.views.gamblingHelpSection.gamstopHeader')
      ),
      React.createElement(
        'p',
        null,
        translate('saferGambling.views.gamblingHelpSection.gamstopContent')
      ),
      React.createElement(
        'div',
        { className: CLASSNAME_PREFIX + '-help-section__gamstop-section-button-wrapper' },
        React.createElement(
          Anchor,
          {
            href: config.gamStopLink,
            target: '_blank',
            rel: 'noopener noreferrer',
            onClick: handleGamStopClick,
            outfit: 'button blue large expanded',
            className: CLASSNAME_PREFIX + '-help-section__gamstop-section-button'
          },
          translate('saferGambling.views.gamblingHelpSection.gamstopButton')
        )
      )
    ),
    React.createElement(
      'div',
      { className: CLASSNAME_PREFIX + '-help-section__advice' },
      React.createElement(
        'h3',
        { className: CLASSNAME_PREFIX + '-help-section__title' },
        translate('saferGambling.views.gamblingHelpSection.bottomSectionTitle')
      ),
      React.createElement(
        'p',
        { className: CLASSNAME_PREFIX + '-help-section__text' },
        translate('saferGambling.views.gamblingHelpSection.bottomSectionText')
      ),
      React.createElement(
        'div',
        { className: CLASSNAME_PREFIX + '-help-section__buttons' },
        shouldShowLink && React.createElement(
          Anchor,
          {
            className: CLASSNAME_PREFIX + '-help-section__button',
            href: config.firstButtonLink,
            target: '_blank',
            rel: 'noopener noreferrer',
            outfit: 'button white large expanded'
          },
          translate('saferGambling.views.gamblingHelpSection.bottomSectionFirstButton')
        ),
        shouldShowLink && React.createElement(
          Anchor,
          {
            className: CLASSNAME_PREFIX + '-help-section__button',
            href: config.secondButtonLink,
            target: '_blank',
            rel: 'noopener noreferrer',
            outfit: 'button white large expanded'
          },
          translate('saferGambling.views.gamblingHelpSection.bottomSectionSecondButton')
        ),
        React.createElement(
          Anchor,
          {
            className: CLASSNAME_PREFIX + '-help-section__button',
            href: config.thirdButtonLink,
            target: '_blank',
            rel: 'noopener noreferrer',
            outfit: 'button white large expanded'
          },
          translate('saferGambling.views.gamblingHelpSection.bottomSectionThirdButton')
        )
      )
    )
  );
};